import { ShowcaseOrientation } from '../domain/types/showcaseTypes';

export const showcaseOrientationLabels: Record<ShowcaseOrientation, string> = {
  LANDSCAPE: 'Orizzontale',
  PORTRAIT: 'Verticale',
};
